import { useStore } from "@nanostores/react";
import { loadFeatures } from "@/stores/featureStore";
import { FeatureService,FeaturesResult } from "@/api";
import { useState, useEffect } from "react"; // Ensure useState and useEffect are imported

export const ChatbotPage = () => {
  const defaultChatbotUrl = "https://udify.app/chatbot/swvplDNQC5k2yTcr"; // TODO: Query from backend default URL in the future
  const org = useStore($org);
  const [features, setFeatures] = useState<FeaturesResult[]>([]); // Define the state type
  const orgId = org?.id; // Get the organization ID
  const [chatbotUrl, setChatbotUrl] = useState<string | null>(null); // Add state for chatbot URL

  useEffect(() => {
    const fetchFeatures = async () => {
      if (orgId) {
        const fetchedFeatures = await FeatureService.getFeatures(orgId);
        setFeatures(fetchedFeatures);
      }
    };

    fetchFeatures();
  }, [orgId]); // Use orgId as a dependency to ensure it triggers correctly

  const featureId = features.find(feature => feature.name === 'Chatbot Agent' && feature.enabled)?.id;

  useEffect(() => {
    const fetchChatbot = async () => {
      if (featureId && orgId) {
        const chatbot = await FeatureService.getChatbot(featureId, orgId);
        setChatbotUrl(chatbot.url);
      }
    };

    fetchChatbot();
  }, [featureId, orgId]); // Ensure dependencies are correctly set

  return (
    <div>
      <div className="mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Chatbot Agent</h2>
        </div>
      </div>
      <div className="mt-12 flex h-auto w-full flex-col items-center">
        <div className="grid h-[80px] w-8/12 items-center gap-2">
              <iframe
                src={chatbotUrl || defaultChatbotUrl} // Use chatbotUrl for src, fallback to "{}"
                className="h-[80vh] w-full border-0"
                height="650"
                style={{ width: '100%', border: 'none' }}
                frameBorder="0"
                allow="microphone"
              />
        </div>
      </div>
    </div>
  );
};
